export const AUTH_ERROR_CODES = [4001, 4003] as const;

export function isAuthError(code: number): boolean {
  return (AUTH_ERROR_CODES as readonly number[]).includes(code);
}

export function dispatchAuthFailed(storageKey: string, code: number): void {
  window.dispatchEvent(
    new CustomEvent('websocket-auth-failed', {
      detail: { storageKey, code },
    })
  );
}
